<!-- Simulador de Caja Registradora -->
<div class="min-h-screen py-8">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

    <!-- Header del Simulador -->
    <div class="bg-white rounded-lg shadow-sm border mb-8">
      <div class="px-6 py-4 border-b border-gray-200">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-4 min-w-0 flex-1">
            <div class="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
              <i class="fas fa-cash-register text-white text-xl"></i>
            </div>
            <div class="min-w-0 flex-1">
              <h1 class="text-xl sm:text-2xl font-bold text-gray-900 truncate">Simulador de Caja Registradora</h1>
              <p class="text-sm text-gray-500" *ngIf="!cashierSession || !isActive">Inicie sesión para comenzar</p>
              <div class="text-sm text-gray-500" *ngIf="cashierSession && isActive">
                <p class="font-medium truncate">{{ cashierSession.storeName }}</p>
                <p class="text-xs text-gray-400 hidden sm:block">
                  Caja {{ cashierSession.cashRegister }} • 
                  Afiliación {{ getStoreAffiliationNumber() }} • 
                  Cajero: {{ cashierSession.cashierDocument }}
                </p>
                <p class="text-xs text-gray-400 sm:hidden">
                  Caja {{ cashierSession.cashRegister }} • {{ cashierSession.cashierDocument }}
                </p>
              </div>
            </div>
          </div>
          
          <!-- Control Principal -->
          <div class="flex items-center space-x-2 sm:space-x-4 flex-shrink-0">
            <!-- Estado de Conexión -->
            <div class="hidden sm:flex items-center space-x-2" *ngIf="isActive">
              <div class="w-3 h-3 rounded-full" 
                   [class.bg-green-500]="simulatorConfig.isConnected" 
                   [class.bg-red-500]="!simulatorConfig.isConnected"></div>
              <span class="text-sm font-medium" 
                    [class.text-green-700]="simulatorConfig.isConnected" 
                    [class.text-red-700]="!simulatorConfig.isConnected">
                {{ simulatorConfig.isConnected ? 'Conectado' : 'Desconectado' }}
              </span>
            </div>

            <!-- Toggle del Simulador -->
            <button 
              (click)="toggleSimulator()"
              class="flex items-center px-3 sm:px-4 py-2 rounded-lg font-medium transition-colors"
              [class.bg-green-600]="isActive"
              [class.text-white]="isActive"
              [class.hover:bg-green-700]="isActive"
              [class.bg-blue-600]="!isActive"
              [class.text-white]="!isActive"
              [class.hover:bg-blue-700]="!isActive">
              <i class="text-sm" 
                 [class.fas]="true"
                 [class.fa-sign-in-alt]="!isActive"
                 [class.fa-sign-out-alt]="isActive"
                 [class.mr-2]="true"
                 [class.sm:mr-2]="true"></i>
              <span class="hidden sm:inline">{{ isActive ? 'Cerrar Sesión' : 'Iniciar Sesión' }}</span>
              <span class="sm:hidden">{{ isActive ? 'Salir' : 'Entrar' }}</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Breadcrumb -->
      <div class="px-6 py-3 bg-gray-50 border-b border-gray-200" *ngIf="isActive">
        <nav class="flex" aria-label="Breadcrumb">
          <ol class="flex items-center space-x-2">
            <li>
              <span class="text-sm text-gray-500">{{ cashierSession?.storeName }}</span>
            </li>

            <li class="flex items-center" *ngIf="currentView === 'debts' || currentView === 'transactions'">
              <i class="fas fa-chevron-right text-gray-300 text-xs mx-2"></i>
              <span class="text-sm text-blue-600">
                {{ currentView === 'debts' ? 'Consulta de Deudas' : 'Consulta de Transacciones' }}
              </span>
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <!-- Header Sticky del Cliente (aparece cuando hay cliente consultado) -->
    <div *ngIf="clientData && (currentView === 'debts' || currentView === 'transactions')" 
         class="sticky top-0 z-20 bg-white border-b border-gray-200 shadow-sm mb-6">
      <div class="max-w-6xl mx-auto px-4 py-3">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-4">
            <!-- Foto del Cliente -->
            <div class="w-12 h-12 rounded-full overflow-hidden border-2 border-blue-600 flex items-center justify-center bg-gray-100 flex-shrink-0">
              <img *ngIf="clientData?.personCompleteData?.file_selfie?.url" 
                   [src]="sanitize(clientData?.personCompleteData?.file_selfie?.url || '')" 
                   alt="Foto del cliente"
                   class="w-full h-full object-cover">
              <img *ngIf="!clientData?.personCompleteData?.file_selfie?.url"
                   src="../assets/public/images/avatar.png"
                   alt="Avatar del cliente"
                   class="w-full h-full object-cover">
            </div>
            
            <!-- Información del Cliente -->
            <div class="min-w-0 flex-1">
              <!-- Nombre completo -->
              <h2 class="text-lg font-bold text-gray-900 truncate" *ngIf="currentDebts">
                {{ currentDebts?.nombre }} {{ currentDebts?.apellido }}
                {{ currentDebts?.segundo_nombre }} {{ currentDebts?.segundo_apellido }}
              </h2>
              <h2 class="text-lg font-bold text-gray-900 truncate" *ngIf="!currentDebts && clientData?.personCompleteData">
                {{ clientData?.personCompleteData?.name }} {{ clientData?.personCompleteData?.lastName }}
                {{ clientData?.personCompleteData?.second_name }} {{ clientData?.personCompleteData?.second_lastName }}
              </h2>
              <h2 class="text-lg font-bold text-gray-900 truncate" *ngIf="!currentDebts && !clientData?.personCompleteData">
                Cliente: {{ clientData?.identity }}
              </h2>
              
              <!-- Cédula y deuda -->
              <div class="flex items-center space-x-4 text-sm text-gray-600">
                <span *ngIf="currentDebts">
                  {{ currentDebts?.codigo_identificacion }}-{{ currentDebts?.numero_identificacion }}
                </span>
                <span *ngIf="!currentDebts && clientData?.identity">
                  V-{{ clientData?.identity }}
                </span>
                <span *ngIf="currentDebts?.montoDeudaTotalUSD" class="font-medium text-red-600">
                  💰 Deuda Total: ${{ currentDebts?.montoDeudaTotalUSD?.toFixed(2) }}
                </span>
                <span *ngIf="hasActiveQuery && currentTransactionNumber" class="flex items-center text-green-600 font-medium">
                  <i class="fas fa-check-circle mr-1"></i>
                  Consulta activa: #{{ currentTransactionNumber }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Contenido Principal basado en currentView -->
    <div [ngSwitch]="currentView">
      
      <!-- Vista: Búsqueda de Cliente (solo si hay sesión activa) -->
      <div *ngSwitchCase="'client-search'" class="max-w-2xl mx-auto" [hidden]="!isActive || !cashierSession">
        <div class="bg-white rounded-lg shadow-sm border">
          <div class="px-6 py-4 border-b border-gray-200">
            <h2 class="text-lg font-semibold text-gray-900 flex items-center">
              <i class="fas fa-search text-blue-500 mr-2"></i>
              Consultar Cliente
            </h2>
            <p class="text-sm text-gray-500 mt-1">Ingrese la cédula del cliente para consultar su información</p>
          </div>

          <div class="p-6">
            <form [formGroup]="clientForm" (ngSubmit)="searchClient()">
              <div class="space-y-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">
                    Cédula del Cliente *
                  </label>
                  <input 
                    type="text" 
                    formControlName="identity"
                    class="block w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-lg"
                    placeholder="Ej: 14863150"
                    maxlength="10">
                  <div *ngIf="clientForm.get('identity')?.invalid && clientForm.get('identity')?.touched" 
                       class="mt-1 text-sm text-red-600">
                    Ingrese una cédula válida (7-10 dígitos)
                  </div>
                </div>

                <button 
                  type="submit"
                  [disabled]="!clientForm.valid"
                  class="w-full flex items-center justify-center px-4 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                  <i class="fas fa-search mr-2"></i>
                  Consultar Cliente
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- Vista: Opciones de Consulta (solo si hay sesión activa) -->
      <div *ngSwitchCase="'options'" class="max-w-4xl mx-auto" [hidden]="!isActive || !cashierSession">
        <div class="bg-white rounded-lg shadow-sm border mb-6">
          <!-- Información Completa del Cliente -->
          <div class="p-6 border-b border-gray-200 bg-gradient-to-r from-blue-50 to-indigo-50">
            <div class="flex items-center justify-between mb-4">
              <div class="flex items-center space-x-4">
                <!-- Avatar/Selfie del Cliente -->
                <div class="w-16 h-16 rounded-full overflow-hidden border-2 border-blue-600 flex items-center justify-center bg-gray-100">
                  <!-- Selfie del usuario cuando está disponible -->
                  <img *ngIf="clientData?.personCompleteData?.file_selfie?.url" 
                       [src]="sanitize(clientData?.personCompleteData?.file_selfie?.url || '')" 
                       alt="Foto del cliente"
                       class="w-full h-full object-cover">
                  
                  <!-- Avatar genérico cuando no hay selfie -->
                  <img *ngIf="!clientData?.personCompleteData?.file_selfie?.url"
                       src="../assets/public/images/avatar.png"
                       alt="Avatar del cliente"
                       class="w-full h-full object-cover">
                </div>
                
                <!-- Información Personal -->
                <div>
                  <h2 class="text-2xl font-bold text-gray-900" *ngIf="clientData?.fullContactInfo?.person">
                    {{ clientData?.fullContactInfo?.person?.name }} 
                    {{ clientData?.fullContactInfo?.person?.lastName }}
                    {{ clientData?.fullContactInfo?.person?.second_name }}
                    {{ clientData?.fullContactInfo?.person?.second_lastName }}
                  </h2>
                  <h2 class="text-2xl font-bold text-gray-900" *ngIf="!clientData?.fullContactInfo?.person">
                    Cliente: {{ clientData?.identity }}
                  </h2>
                  
                  <div class="flex items-center space-x-4 mt-2">
                    <!-- Cédula -->
                    <div class="flex items-center text-gray-600">
                      <i class="fas fa-id-card mr-2"></i>
                      <span *ngIf="clientData?.fullContactInfo?.identity">
                        V-{{ clientData?.fullContactInfo?.identity }}
                      </span>
                      <span *ngIf="!clientData?.fullContactInfo?.person">
                        V-{{ clientData?.identity }}
                      </span>
                    </div>
                    
                    <!-- Teléfono -->
                    <div class="flex items-center text-gray-600" *ngIf="clientData?.fullContactInfo?.person?.telefono">
                      <i class="fas fa-phone mr-2"></i>
                      <span>{{ clientData?.fullContactInfo?.person?.telefono }}</span>
                    </div>
                    
                    <!-- Email -->
                    <div class="flex items-center text-gray-600" *ngIf="clientData?.fullContactInfo?.person?.email">
                      <i class="fas fa-envelope mr-2"></i>
                      <span>{{ clientData?.fullContactInfo?.person?.email }}</span>
                    </div>
                  </div>
                </div>
              </div>
              
              <button 
                (click)="goBack()"
                class="flex items-center px-3 py-2 text-gray-600 hover:text-gray-800 transition-colors">
                <i class="fas fa-arrow-left mr-2"></i>
                Cambiar Cliente
              </button>
            </div>
            
            <p class="text-sm text-gray-500">Seleccione el tipo de consulta que desea realizar</p>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <!-- Consultar Deudas -->
          <div class="bg-white rounded-lg shadow-sm border hover:shadow-md transition-shadow">
            <div class="p-6">
              <div class="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                <i class="fas fa-file-invoice-dollar text-red-600 text-xl"></i>
              </div>
              
              <!-- Header con indicador de consulta activa -->
              <div class="flex items-center justify-between mb-2">
                <h3 class="text-lg font-semibold text-gray-900">Consultar Deudas</h3>
                <div *ngIf="hasActiveQuery" class="flex items-center text-xs text-green-600 bg-green-50 px-2 py-1 rounded-full">
                  <i class="fas fa-check-circle mr-1"></i>
                  <span class="font-medium">Consulta activa</span>
                </div>
              </div>
              
              <p class="text-gray-500 text-sm mb-6">
                Consulte el estado de las deudas pendientes, créditos activos y cuotas por pagar del cliente.
              </p>
              
              <button 
                (click)="consultDebts()"
                class="w-full flex items-center justify-center px-4 py-3 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 transition-colors">
                <i class="fas fa-file-invoice-dollar mr-2"></i>
                {{ hasActiveQuery ? 'Ver Consulta' : 'Consultar Deudas' }}
              </button>
            </div>
          </div>

          <!-- Consultar Transacciones -->
          <div class="bg-white rounded-lg shadow-sm border hover:shadow-md transition-shadow">
            <div class="p-6">
              <div class="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <i class="fas fa-exchange-alt text-blue-600 text-xl"></i>
              </div>
              <h3 class="text-lg font-semibold text-gray-900 mb-2">Consultar Transacciones</h3>
              <p class="text-gray-500 text-sm mb-6">
                Revise el historial de transacciones, pagos realizados y el estado de los procesos de pago.
              </p>
              <button 
                (click)="consultTransactions()"
                [disabled]="isLoadingTransactions || !clientData?.identity"
                class="w-full flex items-center justify-center px-4 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                <i *ngIf="!isLoadingTransactions" class="fas fa-exchange-alt mr-2"></i>
                <i *ngIf="isLoadingTransactions" class="fas fa-spinner fa-spin mr-2"></i>
                {{ isLoadingTransactions ? 'Consultando...' : 'Consultar Transacciones' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Vista: Deudas (solo si hay sesión activa) -->
      <div *ngSwitchCase="'debts'" class="max-w-6xl mx-auto" [hidden]="!isActive || !cashierSession">
        <div class="bg-white rounded-lg shadow-sm border mb-6">
          <div class="px-6 py-4 border-b border-gray-200">
            <div class="flex items-center justify-between">
              <div>
                <h2 class="text-lg font-semibold text-gray-900">Consulta de Deudas</h2>
              </div>
              <button 
                (click)="goBack()"
                class="flex items-center px-3 py-2 text-gray-600 hover:text-gray-800 transition-colors">
                <i class="fas fa-arrow-left mr-2"></i>
                Volver
              </button>
            </div>
          </div>
          

          
          <!-- Lista Compacta de Créditos -->
          <div class="p-6">
            <div class="flex items-center justify-between mb-4">
              <h3 class="text-lg font-semibold text-gray-900">Créditos Pendientes</h3>
              
              <!-- Botones de acción -->
              <div class="flex items-center space-x-3">
                <!-- Botón Refrescar Consulta -->
                <button *ngIf="hasActiveQuery" 
                        (click)="refreshQuery()"
                        class="bg-orange-500 text-white px-3 py-2 rounded-lg font-medium hover:bg-orange-600 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 text-sm">
                  <i class="fas fa-sync-alt mr-2"></i>
                  Refrescar Consulta
                </button>
                
                <!-- Botón Registrar Pago -->
                <button *ngIf="currentDebts?.invoices && (currentDebts?.invoices?.length || 0) > 0" 
                        (click)="initializePayment()"
                        [disabled]="isProcessingPayment"
                        class="bg-blue-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 text-sm disabled:opacity-50 disabled:cursor-not-allowed">
                  <i *ngIf="!isProcessingPayment" class="fas fa-receipt mr-2"></i>
                  <i *ngIf="isProcessingPayment" class="fas fa-spinner fa-spin mr-2"></i>
                  {{ isProcessingPayment ? 'Procesando...' : 'Registrar Pago' }}
                </button>
                </div>
            </div>
            
            <div class="space-y-3" *ngIf="currentDebts && currentDebts?.invoices?.length; else noInvoices">
              <div *ngFor="let invoice of currentDebts?.invoices; let i = index" 
                   (click)="openDrawer(invoice)"
                   class="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer hover:border-blue-300 group">
                
                <!-- Vista Compacta del Crédito -->
                <div class="p-4">
                  <div class="flex items-center justify-between">
                    <!-- Información Principal -->
                    <div class="flex items-center space-x-3">
                      <div class="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center group-hover:scale-105 transition-transform">
                        <i class="fas fa-credit-card text-white text-sm"></i>
                      </div>
                      <div class="flex-1 min-w-0">
                        <div class="flex items-center space-x-2">
                          <h4 class="text-sm font-semibold text-gray-900 group-hover:text-blue-600 transition-colors">
                            Crédito #{{ invoice.numero_credito }}
                          </h4>
                          <span *ngIf="invoice.principal" 
                                class="px-2 py-0.5 bg-blue-100 text-blue-800 text-xs font-medium rounded-full">
                            Principal
                          </span>
                        </div>
                        <p class="text-xs text-gray-500 truncate">{{ invoice.plan }} • {{ invoice.proveedor }}</p>
                </div>
              </div>
              
                    <!-- Información de Deuda y Estado -->
              <div class="text-right">
                      <p class="text-lg font-bold text-red-600 group-hover:text-red-700 transition-colors">
                        ${{ invoice.deuda_credito.toFixed(2) }} USD
                      </p>
                      <div class="flex items-center justify-end space-x-2 mt-1">
                        <span class="text-xs text-gray-500">
                          {{ invoice.cuotas?.length || 0 }} cuotas
                        </span>
                        <span *ngIf="getOverdueInstallmentsCount(invoice) > 0" 
                              class="px-1.5 py-0.5 bg-red-100 text-red-700 text-xs font-medium rounded">
                          {{ getOverdueInstallmentsCount(invoice) }} vencidas
                        </span>
                        <i class="fas fa-chevron-right text-gray-400 text-xs group-hover:text-blue-500 transition-colors"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <ng-template #noInvoices>
              <div class="text-center py-12">
                <div class="w-16 h-16 mx-auto bg-green-100 rounded-full flex items-center justify-center mb-4">
                  <i class="fas fa-check-circle text-green-600 text-2xl"></i>
                  </div>
                <h3 class="text-lg font-medium text-gray-900 mb-2">Sin créditos pendientes</h3>
                <p class="text-gray-500">Este cliente no tiene créditos pendientes en este momento.</p>
                <p class="text-sm text-green-600 mt-2">¡Su estado crediticio está al día!</p>
              </div>
            </ng-template>
                  </div>
                </div>
              </div>
              
      <!-- Vista: Transacciones (solo si hay sesión activa) -->
      <div *ngSwitchCase="'transactions'" class="max-w-6xl mx-auto" [hidden]="!isActive || !cashierSession">
        <div class="bg-white rounded-lg shadow-sm border mb-6">
          <div class="px-6 py-4 border-b border-gray-200">
            <div class="flex items-center justify-between">
              <div>
                <h2 class="text-lg font-semibold text-gray-900">Transacciones</h2>
                  </div>
              <button 
                (click)="goBack()"
                class="flex items-center px-3 py-2 text-gray-600 hover:text-gray-800 transition-colors">
                <i class="fas fa-arrow-left mr-2"></i>
                Volver
              </button>
            </div>
          </div>
          
          <div class="p-6">
            <!-- Header con controles -->
            <div class="flex items-center justify-between mb-6">
                  <div>
                <h3 class="text-lg font-semibold text-gray-900">Transacciones del Cliente</h3>
                <p class="text-sm text-gray-500 mt-1" *ngIf="!isSelectionMode">Usa el botón para invertir el orden de las listas</p>
                <p class="text-sm text-blue-600 mt-1" *ngIf="isSelectionMode">
                  {{ selectedTransactions.size }} transacción{{ selectedTransactions.size !== 1 ? 'es' : '' }} seleccionada{{ selectedTransactions.size !== 1 ? 's' : '' }}
                </p>
                  </div>
              
              <!-- Controles principales -->
              <div class="flex items-center space-x-3">
                
                <!-- Modo Normal -->
                <div *ngIf="!isSelectionMode" class="flex items-center space-x-3">
                  <!-- Botón Modo Selección -->
                  <button 
                    (click)="toggleSelectionMode()"
                    [disabled]="isLoadingTransactions"
                    class="group flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-red-50 to-red-100 border border-red-200 rounded-lg hover:from-red-100 hover:to-red-200 hover:border-red-300 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed shadow-sm hover:shadow-md">
                    <i class="fas fa-ban text-red-600 group-hover:text-red-700 transition-colors duration-200"></i>
                    <span class="text-sm font-medium text-red-700 group-hover:text-red-800 transition-colors duration-200">
                      Cancelación Múltiple
                    </span>
                  </button>
                  
                  <!-- Botón Invertir Orden -->
                  <button 
                    (click)="toggleTransactionOrder()"
                    [disabled]="isLoadingTransactions"
                    class="group flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-slate-50 to-gray-100 border border-gray-200 rounded-lg hover:from-blue-50 hover:to-blue-100 hover:border-blue-300 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed shadow-sm hover:shadow-md">
                    <div class="relative">
                      <i class="fas fa-sort-amount-down text-gray-600 group-hover:text-blue-600 transition-colors duration-200"
                         [class.rotate-180]="isTransactionOrderAsc"
                         style="transition: transform 0.3s ease;"></i>
                </div>
                    <span class="text-sm font-medium text-gray-700 group-hover:text-blue-700 transition-colors duration-200">
                      Invertir Orden
                    </span>
                  </button>
              </div>
              
                <!-- Modo Selección -->
                <div *ngIf="isSelectionMode" class="flex items-center space-x-3">
                  <!-- Seleccionar Todas -->
                  <button 
                    (click)="selectAllVisibleTransactions()"
                    class="flex items-center space-x-2 px-3 py-2 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 hover:border-blue-300 transition-all duration-200 text-sm font-medium text-blue-700">
                    <i class="fas fa-check-double"></i>
                    <span>Todas</span>
                  </button>
                  
                  <!-- Limpiar Selección -->
                  <button 
                    (click)="clearAllSelections()"
                    class="flex items-center space-x-2 px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg hover:bg-gray-100 hover:border-gray-300 transition-all duration-200 text-sm font-medium text-gray-700">
                    <i class="fas fa-times"></i>
                    <span>Limpiar</span>
                  </button>
                  
                  <!-- Borrar Selección -->
                  <button 
                    (click)="deleteSelectedTransactions()"
                    [disabled]="selectedTransactions.size === 0"
                    class="flex items-center space-x-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-all duration-200 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed">
                    <i class="fas fa-trash-alt"></i>
                    <span>Borrar Selección ({{ selectedTransactions.size }})</span>
                  </button>
                  
                  <!-- Salir del modo selección -->
                  <button 
                    (click)="toggleSelectionMode()"
                    class="flex items-center space-x-2 px-3 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-all duration-200 text-sm font-medium">
                    <i class="fas fa-arrow-left"></i>
                    <span>Salir</span>
                  </button>
                  </div>
                
                  </div>
                </div>

            <!-- Loading State -->
            <div *ngIf="isLoadingTransactions" class="text-center py-8">
              <div class="inline-flex items-center">
                <i class="fas fa-spinner fa-spin text-blue-600 mr-3"></i>
                <span class="text-gray-600">Cargando transacciones...</span>
              </div>
            </div>

            <!-- Transacciones Content -->
            <div *ngIf="!isLoadingTransactions" class="grid grid-cols-1 md:grid-cols-3 gap-6">
              
              <!-- 1. IN_PROCESS Transactions -->
              <div class="bg-amber-50 border border-amber-200 rounded-xl p-4 h-fit">
                <div class="flex items-center mb-3">
                  <div class="w-3 h-3 bg-amber-500 rounded-full mr-3"></div>
                  <h4 class="font-semibold text-amber-800">EN PROCESO</h4>
                  <span class="ml-2 text-xs text-amber-600 bg-amber-100 px-2 py-1 rounded">{{ inProcessTransactions.length }}</span>
          </div>
          
                <div *ngIf="inProcessTransactions.length === 0" class="text-amber-600 text-sm italic">
                  No hay transacciones en proceso
                </div>
                
                <div *ngIf="inProcessTransactions.length > 0" class="space-y-2">
                  <div *ngFor="let transaction of inProcessTransactions; trackBy: trackByTransactionNumber" 
                       class="group relative bg-white border border-amber-200 rounded-lg p-3 shadow-sm hover:shadow-md transition-all duration-200 hover:border-amber-300">
                    
                    <!-- Línea principal: Número + Ícono + Botón -->
                  <div class="flex items-center justify-between">
                      <div class="flex items-center space-x-3">
                        <!-- Ícono del estado -->
                        <div class="w-8 h-8 bg-amber-100 rounded-lg flex items-center justify-center">
                          <i class="fas fa-clock text-amber-600 text-sm"></i>
                      </div>
                        
                        <!-- Número de transacción destacado -->
                        <div class="font-mono text-lg font-bold text-gray-900 tracking-tight">
                          #{{ transaction.transactionNumber }}
                      </div>
                    </div>
                    
                      <!-- Controles de acción -->
                      <div class="flex items-center">
                        <!-- Modo Selección: Checkbox -->
                        <div *ngIf="isSelectionMode" 
                             (click)="toggleTransactionSelection(transaction.transactionNumber); $event.stopPropagation()"
                             class="w-6 h-6 border-2 border-amber-400 rounded flex items-center justify-center cursor-pointer transition-colors duration-200"
                             [class.bg-amber-500]="isTransactionSelected(transaction.transactionNumber)"
                             [class.border-amber-500]="isTransactionSelected(transaction.transactionNumber)"
                             title="Seleccionar transacción">
                          <i *ngIf="isTransactionSelected(transaction.transactionNumber)" 
                             class="fas fa-check text-white text-xs"></i>
                    </div>
                        
                        <!-- Modo Normal: Botón Cancelar -->
                        <button *ngIf="!isSelectionMode"
                                (click)="cancelTransaction(transaction.transactionNumber); $event.stopPropagation()" 
                                class="w-6 h-6 bg-red-500 hover:bg-red-600 rounded-full flex items-center justify-center text-white text-xs font-bold transition-all duration-200 hover:scale-110 shadow-sm hover:shadow-md"
                                title="Cancelar transacción">
                          <i class="fas fa-times"></i>
                        </button>
                  </div>
                </div>
                
                    <!-- Fecha (línea secundaria) -->
                    <div class="mt-2 ml-11 text-xs text-gray-500">
                      <i class="fas fa-calendar-alt mr-1.5 text-amber-400"></i>
                      {{ transaction.date | date:'dd/MM/yyyy HH:mm' }}
                    </div>
                    
                    <!-- Tienda (línea terciaria) -->
                    <div *ngIf="transaction.session_created?.shop" class="mt-1 ml-11 text-xs text-gray-500">
                      <i class="fas fa-store mr-1.5 text-amber-400"></i>
                      Tienda: {{ transaction.session_created.shop }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- 2. IN_PAYMENT Transactions -->
              <div class="bg-blue-50 border border-blue-200 rounded-xl p-4 h-fit">
                <div class="flex items-center mb-3">
                  <div class="w-3 h-3 bg-blue-500 rounded-full mr-3"></div>
                  <h4 class="font-semibold text-blue-800">EN PAGO</h4>
                  <span class="ml-2 text-xs text-blue-600 bg-blue-100 px-2 py-1 rounded">{{ inPaymentTransactions.length }}</span>
                              </div>
                
                <div *ngIf="inPaymentTransactions.length === 0" class="text-blue-600 text-sm italic">
                  No hay transacciones en pago
                            </div>
                
                <div *ngIf="inPaymentTransactions.length > 0" class="space-y-2">
                  <div *ngFor="let transaction of inPaymentTransactions; trackBy: trackByTransactionNumber" 
                       class="group relative bg-white border border-blue-200 rounded-lg p-3 shadow-sm hover:shadow-md transition-all duration-200 hover:border-blue-300">
                    
                    <!-- Línea principal: Número + Ícono + Botón -->
                    <div class="flex items-center justify-between">
                      <div class="flex items-center space-x-3">
                        <!-- Ícono del estado -->
                        <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                          <i class="fas fa-credit-card text-blue-600 text-sm"></i>
                            </div>
                        
                        <!-- Número de transacción destacado -->
                        <div class="font-mono text-lg font-bold text-gray-900 tracking-tight">
                          #{{ transaction.transactionNumber }}
                        </div>
                      </div>
                      
                      <!-- Controles de acción -->
                      <div class="flex items-center space-x-2">
                        <!-- Modo Selección: Checkbox -->
                        <div *ngIf="isSelectionMode" 
                             (click)="toggleTransactionSelection(transaction.transactionNumber); $event.stopPropagation()"
                             class="w-6 h-6 border-2 border-blue-400 rounded flex items-center justify-center cursor-pointer transition-colors duration-200"
                             [class.bg-blue-500]="isTransactionSelected(transaction.transactionNumber)"
                             [class.border-blue-500]="isTransactionSelected(transaction.transactionNumber)"
                             title="Seleccionar transacción">
                          <i *ngIf="isTransactionSelected(transaction.transactionNumber)" 
                             class="fas fa-check text-white text-xs"></i>
                  </div>
                        
                        <!-- Modo Normal: Botones de Acción -->
                        <div *ngIf="!isSelectionMode" class="flex items-center space-x-2">
                          <!-- Botón Completar Pago -->
                          <button (click)="openCompletePaymentModal(transaction); $event.stopPropagation()" 
                                  class="w-6 h-6 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center text-white text-xs font-bold transition-all duration-200 hover:scale-110 shadow-sm hover:shadow-md"
                                  title="Completar Pago">
                            <i class="fas fa-dollar-sign"></i>
                          </button>
                          
                          <!-- Botón Cancelar -->
                          <button (click)="cancelTransaction(transaction.transactionNumber); $event.stopPropagation()" 
                                  class="w-6 h-6 bg-red-500 hover:bg-red-600 rounded-full flex items-center justify-center text-white text-xs font-bold transition-all duration-200 hover:scale-110 shadow-sm hover:shadow-md"
                                  title="Cancelar transacción">
                            <i class="fas fa-times"></i>
                          </button>
                        </div>
                </div>
              </div>
                    
                    <!-- Fecha (línea secundaria) -->
                    <div class="mt-2 ml-11 text-xs text-gray-500">
                      <i class="fas fa-calendar-alt mr-1.5 text-blue-400"></i>
                      {{ transaction.date | date:'dd/MM/yyyy HH:mm' }}
            </div>
            
                    <!-- Tienda (línea terciaria) -->
                    <div *ngIf="transaction.session_created?.shop" class="mt-1 ml-11 text-xs text-gray-500">
                      <i class="fas fa-store mr-1.5 text-blue-400"></i>
                      Tienda: {{ transaction.session_created.shop }}
                </div>
              </div>
          </div>
        </div>

              <!-- 3. FINISHED Transactions -->
              <div class="bg-green-50 border border-green-200 rounded-xl p-4 h-fit">
                <div class="flex items-center mb-3">
                  <div class="w-3 h-3 bg-green-500 rounded-full mr-3"></div>
                  <h4 class="font-semibold text-green-800">FINALIZADAS</h4>
                  <span class="ml-2 text-xs text-green-600 bg-green-100 px-2 py-1 rounded">{{ finishedTransactions.length }}</span>
      </div>

                <div *ngIf="finishedTransactions.length === 0" class="text-green-600 text-sm italic">
                  No hay transacciones finalizadas
                </div>
                
                <div *ngIf="finishedTransactions.length > 0" class="space-y-2">
                  <div *ngFor="let transaction of finishedTransactions; trackBy: trackByTransactionNumber" 
                       class="group relative bg-white border border-green-200 rounded-lg p-3 shadow-sm hover:shadow-md transition-all duration-200 hover:border-green-300">
                    
                    <!-- Línea principal: Número + Ícono -->
            <div class="flex items-center justify-between">
                      <div class="flex items-center space-x-3">
                        <!-- Ícono del estado -->
                        <div class="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center">
                          <i class="fas fa-check-circle text-green-600 text-sm"></i>
              </div>
                        
                        <!-- Número de transacción destacado -->
                        <div class="font-mono text-lg font-bold text-gray-900 tracking-tight">
                          #{{ transaction.transactionNumber }}
            </div>
          </div>
          
                      <!-- Badge completado (opcional) -->
                      <div class="bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs font-medium">
                        Completada
            </div>
          </div>
                    
                    <!-- Fecha (línea secundaria) -->
                    <div class="mt-2 ml-11 text-xs text-gray-500">
                      <i class="fas fa-calendar-check mr-1.5 text-green-400"></i>
                      {{ transaction.date | date:'dd/MM/yyyy HH:mm' }}
                    </div>
                    
                    <!-- Tienda (línea terciaria) -->
                    <div *ngIf="transaction.session_created?.shop" class="mt-1 ml-11 text-xs text-gray-500">
                      <i class="fas fa-store mr-1.5 text-green-400"></i>
                      Tienda: {{ transaction.session_created.shop }}
                    </div>
                    
                    <!-- Botón Ver Detalle del Pago -->
                    <div *ngIf="transaction.payments && transaction.payments.length > 0" class="mt-3 ml-11">
                      <button (click)="openPaymentDetailModal(transaction)" 
                              class="text-xs bg-green-50 hover:bg-green-100 text-green-700 px-3 py-1.5 rounded-lg border border-green-200 transition-colors duration-200 flex items-center space-x-2">
                        <i class="fas fa-receipt"></i>
                        <span>Ver Detalle del Pago</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            
            <!-- Info Helper -->
            <div *ngIf="!isLoadingTransactions && inProcessTransactions.length === 0 && inPaymentTransactions.length === 0 && finishedTransactions.length === 0" 
                 class="text-center py-8 bg-gray-50 rounded-xl border-2 border-dashed border-gray-300 mt-6">
              <i class="fas fa-info-circle text-gray-400 text-2xl mb-2"></i>
              <p class="text-gray-500">Las transacciones se cargarán automáticamente</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Vista por defecto: No autenticado -->
      <div *ngSwitchDefault class="max-w-2xl mx-auto">
        <div class="bg-white rounded-lg shadow-sm border">
          <div class="p-8 text-center">
            <div class="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i class="fas fa-lock text-gray-400 text-2xl"></i>
            </div>
            <h3 class="text-lg font-semibold text-gray-900 mb-2">Acceso Restringido</h3>
            <p class="text-gray-500 mb-6">
              Debe iniciar sesión como cajero para acceder al simulador de caja registradora.
            </p>
            <button 
              (click)="toggleSimulator()"
              class="px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors">
              <i class="fas fa-sign-in-alt mr-2"></i>
              Iniciar Sesión
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Login de Caja -->
<div *ngIf="showLoginModal" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <!-- Overlay -->
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" (click)="closeLoginModal()"></div>

    <!-- Modal -->
    <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
      <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
        <div class="sm:flex sm:items-start">
          <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
            <i class="fas fa-cash-register text-blue-600"></i>
          </div>
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left flex-1">
            <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">
              Autenticación de Caja
            </h3>
            <div class="mt-2">
              <p class="text-sm text-gray-500">
                Ingrese sus credenciales para iniciar sesión como cajero.
              </p>
            </div>

            <!-- Formulario de Login -->
            <form [formGroup]="loginForm" (ngSubmit)="authenticateCashier()" class="mt-6 space-y-4">
              
              <!-- Select de Tiendas con Búsqueda -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  Tienda *
                </label>
                <div class="relative">
                  <input 
                    type="text" 
                    formControlName="storeSearch"
                    class="block w-full px-3 py-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                    [class.border-green-300]="loginForm.get('selectedStore')?.value"
                    [class.bg-green-50]="loginForm.get('selectedStore')?.value"
                    [class.border-gray-300]="!loginForm.get('selectedStore')?.value"
                    [class.pr-10]="loginForm.get('selectedStore')?.value"
                    placeholder="Buscar tienda por código o nombre..."
                    autocomplete="off"
                    (input)="onStoreSearchChange($event)"
                    (keyup)="onStoreSearchChange($event)">
                  
                  <!-- Botón para limpiar selección -->
                  <div *ngIf="loginForm.get('selectedStore')?.value" 
                       class="absolute inset-y-0 right-0 flex items-center pr-3 space-x-1">
                    <button 
                      type="button"
                      (click)="clearStoreSelection()"
                      class="text-gray-400 hover:text-red-500 transition-colors"
                      title="Cambiar tienda">
                      <i class="fas fa-times"></i>
                    </button>
                    <i class="fas fa-check text-green-500"></i>
                  </div>
                </div>
                
                <!-- Lista de tiendas filtradas -->
                <div *ngIf="filteredStores.length > 0 && loginForm.get('storeSearch')?.value && !loginForm.get('selectedStore')?.value" 
                     class="absolute z-10 mt-1 left-0 right-0 bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none">
                  <div *ngFor="let store of filteredStores.slice(0, 10)"
                       (click)="onStoreSelect(store)"
                       class="cursor-pointer select-none relative py-3 pl-3 pr-9 hover:bg-blue-50 border-b border-gray-100 last:border-b-0">
                    <div>
                      <span class="font-medium block truncate text-gray-900">{{ store.description }}</span>
                      <span class="text-gray-500 text-sm block truncate mt-1">{{ store.code }} - {{ store.short_name }}{{ store.afiliation_number ? ' - ' + store.afiliation_number : '' }}</span>
                    </div>
                  </div>
                </div>
                
                <div *ngIf="loginForm.get('selectedStore')?.invalid && loginForm.get('selectedStore')?.touched" 
                     class="mt-1 text-sm text-red-600">
                  Seleccione una tienda
                </div>
              </div>

              <!-- Número de Caja -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  Número de Caja *
                </label>
                <input 
                  type="number" 
                  formControlName="cashRegister"
                  class="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Ej: 1, 2, 3..."
                  min="1">
                <div *ngIf="loginForm.get('cashRegister')?.invalid && loginForm.get('cashRegister')?.touched" 
                     class="mt-1 text-sm text-red-600">
                  Ingrese un número de caja válido
                </div>
              </div>

              <!-- Cédula del Cajero -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  Cédula del Cajero *
                </label>
                <input 
                  type="text" 
                  formControlName="cashierDocument"
                  class="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Ej: 19820976"
                  maxlength="10">
                <div *ngIf="loginForm.get('cashierDocument')?.invalid && loginForm.get('cashierDocument')?.touched" 
                     class="mt-1 text-sm text-red-600">
                  Ingrese una cédula válida (7-10 dígitos)
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- Botones del Modal -->
      <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
        <button 
          type="button"
          (click)="authenticateCashier()"
          [disabled]="!loginForm.valid || isAuthenticating"
          class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed">
          <i *ngIf="isAuthenticating" class="fas fa-spinner fa-spin mr-2"></i>
          <i *ngIf="!isAuthenticating" class="fas fa-sign-in-alt mr-2"></i>
          {{ isAuthenticating ? 'Autenticando...' : 'Iniciar Sesión' }}
        </button>
        <button 
          type="button"
          (click)="closeLoginModal()"
          [disabled]="isAuthenticating"
          class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ===== SLIDING DRAWER ===== -->
<div class="drawer-overlay fixed inset-0 z-50 overflow-hidden"
     [class.active]="isDrawerOpen"
     [class.pointer-events-none]="!isDrawerOpen"
     [class.pointer-events-auto]="isDrawerOpen"
     (click)="closeDrawer()">
  
  <!-- Panel Deslizante desde la Derecha -->
  <div class="drawer-panel fixed top-0 right-0 h-full w-full max-w-md bg-white shadow-2xl transform transition-transform duration-300 ease-out border-l border-gray-200"
       [class.translate-x-full]="!isDrawerOpen"
       [class.translate-x-0]="isDrawerOpen"
       (click)="$event.stopPropagation()">
    
    <!-- Header del Drawer -->
    <div class="drawer-header bg-blue-600 text-white p-6 relative border-b border-gray-200">
      <!-- Botón Cerrar -->
      <button (click)="closeDrawer()" 
              class="absolute top-4 right-4 w-8 h-8 rounded-full bg-white bg-opacity-20 hover:bg-opacity-30 flex items-center justify-center transition-all">
        <i class="fas fa-times text-sm"></i>
      </button>
      
      <!-- Navegación entre Créditos -->
      <div class="flex items-center justify-between mb-4" *ngIf="currentDebts?.invoices && (currentDebts?.invoices?.length || 0) > 1">
        <button (click)="navigateInvoice('prev')" 
                [disabled]="selectedInvoiceIndex <= 0"
                class="w-8 h-8 rounded-full bg-white bg-opacity-20 hover:bg-opacity-30 disabled:opacity-50 flex items-center justify-center transition-all">
          <i class="fas fa-chevron-left text-sm"></i>
        </button>
        
        <span class="text-sm font-medium">
          {{ selectedInvoiceIndex + 1 }} de {{ currentDebts?.invoices?.length || 0 }}
        </span>
        
        <button (click)="navigateInvoice('next')" 
                [disabled]="selectedInvoiceIndex >= (currentDebts?.invoices?.length || 0) - 1"
                class="w-8 h-8 rounded-full bg-white bg-opacity-20 hover:bg-opacity-30 disabled:opacity-50 flex items-center justify-center transition-all">
          <i class="fas fa-chevron-right text-sm"></i>
        </button>
      </div>
      
      <!-- Información del Crédito -->
      <div *ngIf="selectedInvoice" class="text-center">
        <h2 class="text-xl font-bold mb-1">
          Crédito #{{ selectedInvoice.numero_credito }}
        </h2>
        <p class="text-white text-opacity-90 text-sm">
          {{ selectedInvoice.plan }} • {{ selectedInvoice.proveedor }}
        </p>
        <span *ngIf="selectedInvoice.principal" 
              class="inline-block mt-2 px-3 py-1 bg-white bg-opacity-20 text-xs font-medium rounded-full">
          Crédito Principal
        </span>
      </div>
    </div>
    
    <!-- Contenido del Drawer -->
    <div class="drawer-content flex-1 overflow-y-auto p-6" *ngIf="selectedInvoice">
      
      <!-- Resumen Financiero -->
      <div class="bg-gray-50 rounded-lg p-4 mb-6 border border-gray-200">
        <h3 class="text-sm font-semibold text-gray-900 mb-3">Resumen Financiero</h3>
        <div class="grid grid-cols-2 gap-4">
          <div>
            <p class="text-xs text-gray-500">Monto Original</p>
            <p class="text-lg font-bold text-gray-900">${{ selectedInvoice.monto_credito.toFixed(2) }} USD</p>
          </div>
          <div>
            <p class="text-xs text-gray-500">Deuda Actual</p>
            <p class="text-lg font-bold text-red-600">${{ selectedInvoice.deuda_credito.toFixed(2) }} USD</p>
          </div>
        </div>
        <div class="mt-3 bg-white rounded-lg p-3 border border-gray-100">
          <div class="flex justify-between items-center text-sm">
            <span class="text-gray-600">Progreso de Pago</span>
            <span class="font-medium text-blue-600">{{ ((selectedInvoice.monto_credito - selectedInvoice.deuda_credito) / selectedInvoice.monto_credito * 100).toFixed(1) }}%</span>
          </div>
          <div class="mt-2 w-full bg-gray-200 rounded-full h-2">
            <div class="bg-blue-600 h-2 rounded-full transition-all duration-500" 
                 [style.width.%]="(selectedInvoice.monto_credito - selectedInvoice.deuda_credito) / selectedInvoice.monto_credito * 100"></div>
          </div>
        </div>
      </div>
      
      <!-- Lista de Cuotas -->
      <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
        <h3 class="text-sm font-semibold text-gray-900 mb-4">
          Cuotas ({{ selectedInvoice.cuotas?.length || 0 }})
        </h3>
        
        <div class="space-y-3" *ngIf="selectedInvoice.cuotas">
          <div *ngFor="let cuota of selectedInvoice.cuotas" 
               class="bg-white rounded-lg p-4 border-l-4 transition-all hover:shadow-sm"
               [class.border-red-400]="cuota.cuota_vencida"
               [class.border-green-400]="!cuota.cuota_vencida"
               [class.bg-red-50]="cuota.cuota_vencida">
            
            <div class="flex items-center justify-between">
              <!-- Número y Estado -->
              <div class="flex items-center space-x-3">
                <div class="w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold"
                     [class.bg-red-100]="cuota.cuota_vencida"
                     [class.text-red-700]="cuota.cuota_vencida"
                     [class.bg-green-100]="!cuota.cuota_vencida"
                     [class.text-green-700]="!cuota.cuota_vencida">
                  {{ cuota.num_cuota }}
                </div>
                <div>
                  <p class="text-sm font-medium text-gray-900">
                    ${{ cuota.monto_deuda_usd.toFixed(2) }} USD
                  </p>
                  <p class="text-xs text-gray-500">
                    <i class="fas fa-calendar-alt mr-1"></i>
                    {{ cuota.fecha_vencimiento }}
                  </p>
                </div>
              </div>
              
              <!-- Estado Visual -->
              <div class="text-right">
                <span *ngIf="cuota.cuota_vencida" 
                      class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
                  <i class="fas fa-exclamation-triangle mr-1"></i>
                  Vencida
                </span>
                <span *ngIf="!cuota.cuota_vencida" 
                      class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                  <i class="fas fa-check-circle mr-1"></i>
                  Al día
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Acciones Rápidas -->
      <div class="mt-6">
        <button class="w-full bg-gray-100 text-gray-700 py-3 rounded-lg font-medium hover:bg-gray-200 transition-colors duration-200 border border-gray-200">
          <i class="fas fa-download mr-2"></i>
          Descargar Detalle
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ===== MODAL DE REGISTRO DE PAGO ===== -->
<div class="payment-modal fixed inset-0 z-50 overflow-y-auto"
     [class.pointer-events-none]="!showPaymentModal"
     [class.pointer-events-auto]="showPaymentModal"
     *ngIf="showPaymentModal"
     (click)="closePaymentModal()">
  
  <!-- Backdrop Sutil -->
  <div class="absolute inset-0 bg-white bg-opacity-80 backdrop-blur-sm transition-opacity duration-300"></div>
  
  <!-- Modal Panel -->
  <div class="relative min-h-screen flex items-center justify-center p-4">
    <div class="bg-white rounded-lg shadow-2xl border border-gray-200 max-w-md w-full transform transition-all duration-300 max-h-[90vh] overflow-y-auto"
         [class.scale-95]="!showPaymentModal"
         [class.scale-100]="showPaymentModal"
         (click)="$event.stopPropagation()"
         style="box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);">
      
      <!-- Header -->
      <div class="bg-blue-600 text-white px-6 py-4 rounded-t-lg">
        <div class="flex items-center justify-between">
          <h3 class="text-lg font-semibold">
            <i class="fas fa-receipt mr-2" *ngIf="!isCompletePaymentMode"></i>
            <i class="fas fa-check-circle mr-2" *ngIf="isCompletePaymentMode"></i>
            {{ isCompletePaymentMode ? 'Completar Pago' : 'Registrar Pago' }}
          </h3>
          <button (click)="closePaymentModal()" 
                  class="w-8 h-8 rounded-full bg-white bg-opacity-20 hover:bg-opacity-30 flex items-center justify-center transition-all">
            <i class="fas fa-times text-sm"></i>
          </button>
        </div>
      </div>
      
      <!-- Content -->
      <div class="p-6">
        <!-- Información de la transacción (solo en modo completar pago) -->
        <div *ngIf="isCompletePaymentMode && selectedTransactionForCompletion" class="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
          <div class="text-sm text-blue-800 font-medium mb-2">
            <i class="fas fa-info-circle mr-1"></i>
            Transacción seleccionada:
          </div>
          <div class="space-y-1 text-sm">
            <div class="flex justify-between">
              <span class="text-gray-600">Número:</span>
              <span class="font-mono font-semibold">#{{ selectedTransactionForCompletion.transactionNumber }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-600">Cliente:</span>
              <span class="font-medium">{{ selectedTransactionForCompletion.person?.nombre }} {{ selectedTransactionForCompletion.person?.apellido }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-600">Cédula:</span>
              <span class="font-mono">{{ selectedTransactionForCompletion.identity }}</span>
            </div>
            <div class="flex justify-between" *ngIf="selectedTransactionForCompletion.installment">
              <span class="text-gray-600">Cuota:</span>
              <span class="font-medium">${{ selectedTransactionForCompletion.installment.monto_deuda_usd | number:'1.2-2' }} USD</span>
            </div>
          </div>
        </div>

        <form [formGroup]="paymentRegistrationForm" (ngSubmit)="submitPayment()">
          
          <!-- Información del Cliente -->
          <div class="bg-gray-50 rounded-lg p-4 mb-6 border border-gray-200">
            <h4 class="text-sm font-semibold text-gray-900 mb-2">Cliente</h4>
            <div *ngIf="currentDebts" class="text-sm text-gray-600">
              <p class="font-medium">{{ currentDebts.nombre }} {{ currentDebts.apellido }}</p>
              <p class="text-xs">{{ currentDebts.codigo }}</p>
            </div>
          </div>
          
          <!-- Campos del Formulario -->
          <div class="space-y-4">
            <!-- Monto -->
            <div>
              <label for="amount" class="block text-sm font-medium text-gray-700 mb-1">
                Monto a Pagar <span class="text-red-500">*</span>
              </label>
              <div class="relative">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span class="text-gray-500 text-sm">Bs</span>
                </div>
                <input type="number" 
                       id="amount"
                       formControlName="amount"
                       step="0.01"
                       min="0.01"
                       placeholder="0.00"
                       class="block w-full pl-8 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm">
              </div>
              <div *ngIf="paymentRegistrationForm.get('amount')?.invalid && paymentRegistrationForm.get('amount')?.touched"
                   class="mt-1 text-sm text-red-600">
                Ingrese un monto válido mayor a Bs 0.01
              </div>
            </div>
            
            <!-- Método de Pago -->
            <div>
              <label for="paymentMethod" class="block text-sm font-medium text-gray-700 mb-1">
                Método de Pago <span class="text-red-500">*</span>
              </label>
              <select id="paymentMethod"
                      formControlName="paymentMethod"
                      class="block w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm">
                <option value="">Seleccionar método de pago</option>
                <option *ngFor="let method of cashRegisterPaymentMethods" [value]="method.code">
                  {{ method.name }}
                </option>
              </select>
              <div *ngIf="paymentRegistrationForm.get('paymentMethod')?.invalid && paymentRegistrationForm.get('paymentMethod')?.touched"
                   class="mt-1 text-sm text-red-600">
                Seleccione un método de pago
              </div>
            </div>
            
            <!-- Referencia -->
            <div>
              <label for="reference" class="block text-sm font-medium text-gray-700 mb-1">
                Referencia del Pago <span class="text-red-500">*</span>
              </label>
              <input type="text" 
                     id="reference"
                     formControlName="reference"
                     placeholder="Ej: TRF-123456, CHK-789"
                     class="block w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm">
              <div *ngIf="paymentRegistrationForm.get('reference')?.invalid && paymentRegistrationForm.get('reference')?.touched"
                   class="mt-1 text-sm text-red-600">
                La referencia es requerida
              </div>
            </div>
            
            <!-- Descripción -->
            <div>
              <label for="description" class="block text-sm font-medium text-gray-700 mb-1">
                Descripción <span class="text-red-500">*</span>
              </label>
              <textarea id="description"
                        formControlName="description"
                        rows="3"
                        placeholder="Descripción del pago, método utilizado, etc."
                        class="block w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm resize-none"></textarea>
              <div *ngIf="paymentRegistrationForm.get('description')?.invalid && paymentRegistrationForm.get('description')?.touched"
                   class="mt-1 text-sm text-red-600">
                La descripción es requerida
              </div>
            </div>
          </div>
          
          <!-- Botones -->
          <div class="flex space-x-3 mt-6">
            <button type="button" 
                    (click)="closePaymentModal()"
                    class="flex-1 bg-gray-100 text-gray-700 py-3 rounded-lg font-medium hover:bg-gray-200 transition-colors duration-200 border border-gray-200">
              Cancelar
            </button>
            <button type="submit" 
                    [disabled]="!paymentRegistrationForm.valid"
                    class="flex-1 bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed">
              <i class="fas fa-check mr-2"></i>
              Confirmar Pago
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- ========================================
     MODAL DESLIZANTE: DETALLE DEL PAGO
     ======================================== -->
<div *ngIf="isPaymentDetailModalOpen" 
     style="position: fixed !important; top: 0 !important; left: 0 !important; right: 0 !important; bottom: 0 !important; z-index: 99999 !important; overflow: hidden !important; background: rgba(0,0,0,0.5) !important; display: block !important;"
     (click)="closePaymentDetailModal()">
  
  <!-- Panel deslizante desde la derecha -->
  <div style="position: absolute !important; top: 0 !important; right: 0 !important; bottom: 0 !important; width: 100% !important; max-width: 48rem !important; background: white !important; box-shadow: -4px 0 16px rgba(0,0,0,0.2) !important; overflow-y: auto !important;"
       (click)="$event.stopPropagation()">
    
    <!-- Header del modal -->
    <div style="position: sticky; top: 0; background: linear-gradient(to right, #2563eb, #1d4ed8); color: white; padding: 1.5rem; box-shadow: 0 2px 8px rgba(0,0,0,0.1); z-index: 10;">
      <div style="display: flex; align-items: center; justify-content: space-between;">
        <div>
          <h3 style="font-size: 1.25rem; font-weight: bold; margin: 0;"><i class="fas fa-receipt" style="margin-right: 0.5rem;"></i>Detalle del Pago</h3>
          <p style="font-size: 0.875rem; margin: 0.25rem 0 0 0; opacity: 0.9;">Información completa de la transacción</p>
        </div>
        <button (click)="closePaymentDetailModal()" 
                style="background: transparent; border: none; color: white; padding: 0.5rem; cursor: pointer; border-radius: 50%;"
                onmouseover="this.style.background='rgba(255,255,255,0.1)'"
                onmouseout="this.style.background='transparent'">
          <i class="fas fa-times" style="font-size: 1.25rem;"></i>
        </button>
      </div>
    </div>

    <!-- Contenido del modal -->
    <div style="padding: 1.5rem; padding-bottom: 6rem;">
      
      <!-- Loading State -->
      <div *ngIf="isLoadingPaymentDetail" style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 3rem 0; text-align: center;">
        <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem; margin-bottom: 1rem;">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <p style="color: #6b7280; margin: 0;">Cargando información del pago...</p>
      </div>

      <!-- Payment Detail Content -->
      <div *ngIf="!isLoadingPaymentDetail && selectedPaymentDetail" class="bg-white rounded-lg shadow-sm border p-6">
        
        <!-- Alertas de Pagos Similares -->
        <div *ngIf="selectedPaymentDetail.payment?.status && selectedPaymentDetail.payment?.payments_similar?.length > 0" 
             class="mb-4">
          <div *ngFor="let ps of selectedPaymentDetail.payment?.payments_similar" 
               class="bg-yellow-50 border border-yellow-300 rounded-lg p-3 mb-2">
            <div class="flex items-start space-x-2">
              <i class="fas fa-exclamation-triangle text-yellow-600 mt-1"></i>
              <div class="text-sm text-yellow-800">
                Existe otro pago con la misma referencia, cuenta depósito y monto.<br>
                <span class="font-bold">Código de pago: {{ ps.code }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Ver Adjunto -->
        <div *ngIf="selectedPaymentDetail.payment?.file" class="mb-4">
          <button (click)="redirectIMG(selectedPaymentDetail.payment?.file?.url)" 
                  class="text-blue-600 hover:text-blue-800 font-medium text-sm flex items-center space-x-1">
            <i class="fas fa-paperclip"></i>
            <span>Ver Adjunto</span>
          </button>
        </div>

        <!-- Grid de información -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          
          <!-- Código -->
          <div>
            <div class="text-sm text-gray-500 mb-1">Código</div>
            <div class="text-sm font-bold text-gray-900">{{ selectedPaymentDetail.payment?.code }}</div>
          </div>

          <!-- Conciliación -->
          <div class="text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Conciliación</div>
            <div class="text-sm font-bold"
                 [ngClass]="{'text-green-600': selectedPaymentDetail.payment?.typeTransaction == 'AUTO', 'text-gray-600': selectedPaymentDetail.payment?.typeTransaction != 'AUTO'}">
              {{ selectedPaymentDetail.payment?.typeTransaction == 'AUTO' ? 
                 (selectedPaymentDetail.payment?.responseAutoConfirm?.source ? findAutopago(selectedPaymentDetail.payment?.responseAutoConfirm?.source) : 'Auto') : 
                 (selectedPaymentDetail.payment?.typeTransaction === 'PENDING' ? 'Automática' : 'Manual') }}
            </div>
          </div>

          <!-- Monto total -->
          <div>
            <div class="text-sm text-gray-500 mb-1">Monto total</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.amount | currency:'USD':'':'1.2-2' }} USD</div>
          </div>

          <!-- Estatus -->
          <div class="text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Estatus</div>
            <div>
              <span *ngIf="selectedPaymentDetail.payment?.reconciled_payment && selectedPaymentDetail.payment?.status"
                    class="inline-block bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-medium">Aprobado</span>
              <span *ngIf="!selectedPaymentDetail.payment?.reconciled_payment && selectedPaymentDetail.payment?.status"
                    class="inline-block bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-xs font-medium">Por conciliar</span>
              <span *ngIf="!selectedPaymentDetail.payment?.status"
                    class="inline-block bg-red-100 text-red-800 px-3 py-1 rounded-full text-xs font-medium">Anulado</span>
            </div>
          </div>

          <!-- Tasa de cambio -->
          <div>
            <div class="text-sm text-gray-500 mb-1">Tasa de cambio</div>
            <div class="font-bold text-gray-900">USD 1 = BS {{ selectedPaymentDetail.payment?.rate | currency:'USD':'':'1.2-2' }}</div>
          </div>

          <!-- Monto del pago -->
          <div class="text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Monto del pago</div>
            <div class="font-bold text-gray-900">{{ selectedPaymentDetail.payment?.counterValue | currency:'USD':'':'1.2-2' }} {{ selectedPaymentDetail.payment?.currency?.name }}</div>
          </div>

          <!-- Tipo de producto -->
          <div class="md:col-span-2">
            <div class="text-sm text-gray-500 mb-1">Tipo de producto</div>
            <div class="font-bold">{{ selectedPaymentDetail.payment?.params?.product_type?.type || 'CREDIT' }}</div>
          </div>

          <!-- Fecha conciliación / Anulación -->
          <div>
            <div class="text-sm text-gray-500 mb-1">Fecha conciliación / Anulación</div>
            <div class="font-bold text-gray-900" *ngIf="selectedPaymentDetail.payment?.reconciled_payment_date">
              {{ selectedPaymentDetail.payment?.reconciled_payment_date | date:'dd/MM/yyyy h:mm:ss a' }}
            </div>
            <div class="text-gray-500" *ngIf="!selectedPaymentDetail.payment?.reconciled_payment_date">-</div>
          </div>

          <!-- Responsable -->
          <div class="text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Responsable</div>
            <div class="font-bold text-gray-900 text-sm capitalize">
              {{ selectedPaymentDetail.payment?.reconciled_payment_ejecutive?.name }} {{ selectedPaymentDetail.payment?.reconciled_payment_ejecutive?.lastName }}
              <span *ngIf="!selectedPaymentDetail.payment?.reconciled_payment_ejecutive">-</span>
            </div>
          </div>

          <!-- Descripción / Motivo de anulación -->
          <div class="md:col-span-2 text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">
              {{ selectedPaymentDetail.payment?.status ? 'Descripción' : 'Motivo de anulación' }}
            </div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.description || '-' }}</div>
          </div>

          <!-- Fecha de reporte -->
          <div>
            <div class="text-sm text-gray-500 mb-1">Fecha de reporte</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.date | date:'dd/MM/yyyy h:mm:ss a' }}</div>
          </div>

          <!-- Canal de reporte -->
          <div class="text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Canal de reporte</div>
            <div class="font-bold text-gray-900 text-sm capitalize">
              <span *ngIf="selectedPaymentDetail.payment?.creator_api?.includes('AG') || selectedPaymentDetail.payment?.creator_api?.includes('AUTOPAGO') || selectedPaymentDetail.payment?.creator_api?.includes('TotalPos')">
                {{ selectedPaymentDetail.payment?.creator_api }}
              </span>
              <span *ngIf="selectedPaymentDetail.payment?.creator_api === 'APP' || selectedPaymentDetail.payment?.creator_api === 'CONSOLE' || selectedPaymentDetail.payment?.creator_api === 'CHATBOT'">
                {{ selectedPaymentDetail.payment?.creator_api }} / {{ selectedPaymentDetail.payment?.creator?.name }} {{ selectedPaymentDetail.payment?.creator?.lastName }}
              </span>
              <span *ngIf="!selectedPaymentDetail.payment?.creator_api">-</span>
            </div>
          </div>

          <!-- Fecha de pago -->
          <div>
            <div class="text-sm text-gray-500 mb-1">Fecha de pago</div>
            <div class="text-gray-900 font-bold">
              {{ selectedPaymentDetail.payment?.register_payment_date ? (selectedPaymentDetail.payment?.register_payment_date | date:'dd/MM/yyyy') : (selectedPaymentDetail.payment?.date | date:'dd/MM/yyyy') }}
            </div>
          </div>

          <!-- Responsable edición -->
          <div class="text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Responsable edición</div>
            <div class="text-gray-900 font-bold capitalize text-sm">
              {{ selectedPaymentDetail.payment?.payment_edit_ejecutive?.name }} {{ selectedPaymentDetail.payment?.payment_edit_ejecutive?.lastName }}
              <span *ngIf="!selectedPaymentDetail.payment?.payment_edit_ejecutive">-</span>
            </div>
          </div>

          <!-- Banco origen -->
          <div>
            <div class="text-sm text-gray-500 mb-1">Banco origen</div>
            <div class="text-gray-900 font-bold">{{ getBankName(selectedPaymentDetail.payment?.bankCode) || '-' }}</div>
          </div>

          <!-- Método de pago -->
          <div class="text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Método de pago</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.account_payment?.payment_method?.name || '-' }}</div>
          </div>

          <!-- Teléfono de origen -->
          <div>
            <div class="text-sm text-gray-500 mb-1">Teléfono de origen</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.phone || '-' }}</div>
          </div>

          <!-- Número de referencia -->
          <div class="text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Número de referencia</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.paymentMethodId || '-' }}</div>
          </div>

          <!-- Cuenta origen -->
          <div>
            <div class="text-sm text-gray-500 mb-1">Cuenta origen (Últimos 6)</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.account || '-' }}</div>
          </div>

          <!-- Cédula/Rif titular -->
          <div class="text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Cédula/Rif titular de la Cta.</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.cid != 'V' ? selectedPaymentDetail.payment?.cid : '-' }}</div>
          </div>

          <!-- Banco destino -->
          <div class="md:col-span-2">
            <div class="text-sm text-gray-500 mb-1">Banco destino</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.account_payment?.bank?.name || '-' }}</div>
          </div>

          <!-- Teléfono destino -->
          <div>
            <div class="text-sm text-gray-500 mb-1">Teléfono destino</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.account_payment?.phone || '-' }}</div>
          </div>

          <!-- Cuenta destino -->
          <div class="text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Cuenta destino</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.account_payment?.number || '-' }}</div>
          </div>

          <!-- Monto sin aplicar -->
          <div *ngIf="selectedPaymentDetail.payment?.totalPaymentDue > 0 && selectedPaymentDetail.payment?.status">
            <div class="text-sm text-gray-500 mb-1">Monto sin aplicar</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.totalPaymentDue | currency:'USD':'':'1.2-2' }} USD</div>
          </div>
        </div>

        <!-- Voucher -->
        <div *ngIf="selectedPaymentDetail.payment?.responseAutoConfirm" class="mt-6">
          <div class="font-bold text-gray-600 mb-2">Voucher</div>
          <div *ngIf="selectedPaymentDetail.payment?.responseAutoConfirm?.descripcion"
               class="text-gray-900 font-bold text-xs mb-2">
            {{ selectedPaymentDetail.payment?.responseAutoConfirm?.descripcion }}
          </div>
          <div *ngIf="selectedPaymentDetail.payment?.responseAutoConfirm?.voucher"
               class="border rounded p-3 bg-gray-50">
            <div class="voucher text-gray-900 uppercase text-xs" [innerHTML]="selectedPaymentDetail.payment?.responseAutoConfirm?.voucher"></div>
          </div>
        </div>

        <!-- Distribución -->
        <div *ngIf="selectedPaymentDetail.installMent?.length > 0" class="mt-6">
          <div class="font-bold text-gray-600 mb-3">Distribución</div>
          <div class="space-y-2">
            <div *ngFor="let item2 of selectedPaymentDetail.installMent" class="grid grid-cols-2 gap-4">
              <div>
                <div class="text-sm">
                  {{ item2?.installMent?.invoice?.identifier }} /
                  {{ item2?.installMent?.order < 1 ? 'Inicial' : 'Cuota ' + item2?.installMent?.order }}
                </div>
                <div class="text-xs text-gray-500">{{ item2?.installMent?.code }}</div>
              </div>
              <div class="text-right text-gray-900 font-medium">
                {{ item2?.amount | currency:'USD':'':'1.2-2' }} USD
              </div>
            </div>
          </div>
        </div>

        <!-- IGTF -->
        <div *ngIf="selectedPaymentDetail.paymen_categ_concept_deduc?.length > 0" class="mt-4">
          <div *ngFor="let item3 of selectedPaymentDetail.paymen_categ_concept_deduc">
            <div *ngIf="item3?.category_concept_deduction?.concept_deduction?.name == 'IGTF'" class="grid grid-cols-2 gap-4">
              <div class="text-sm">
                {{ item3?.category_concept_deduction?.concept_deduction?.name }}
                <span class="text-gray-500" *ngIf="item3?.category_concept_deduction.isPorcent">{{ item3?.category_concept_deduction?.amount }}%</span>
              </div>
              <div class="text-right text-gray-900 font-medium">
                {{ item3?.amount | currency:'USD':'':'1.2-2' }} USD
              </div>
            </div>
          </div>
        </div>

        <!-- Penalidades -->
        <div *ngIf="selectedPaymentDetail.fees?.length > 0" class="mt-6">
          <div class="font-bold text-gray-600 mb-3">Penalidades</div>
          <div class="space-y-2">
            <div *ngFor="let item2 of selectedPaymentDetail.fees" class="grid grid-cols-2 gap-4">
              <div>
                <div class="text-sm">
                  {{ item2?.fee_installment?.installment?.invoice?.identifier }} /
                  {{ item2?.fee_installment?.installment?.order < 1 ? 'Inicial' : 'Cuota ' + item2?.fee_installment?.installment?.order }}
                  <div class="text-xs">{{ item2?.fee_installment?.fee.concept_deduction?.name }}</div>
                </div>
                <div class="text-xs text-gray-500">{{ item2?.fee_installment?.installment?.code }}</div>
              </div>
              <div class="text-right text-gray-900 font-medium">
                {{ item2?.amount | currency:'USD':'':'1.2-2' }} USD
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>